import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Link } from "react-router-dom";
import ComfortTradeModal from "../ComfortTradeModal";
import { formateCoins, newpromotion, promotion } from "../../function";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import { getStock } from "../../services/stock/stockApi";

import { useCurrency } from "../../context/CurrencyContext";

export default function CardPayment({ offer, discount }) {
  const { t } = useTranslation();
  const [stock, setStock] = useState([]);
  const { formatPrice, currency, getSymbol } = useCurrency();



  const getsInitialStock = (type) => {
    getStock(type).then((response) => {
      setStock(response.data.total_amount);
    });
  };

  useEffect(() => {
    if (offer.type_id) {
      getsInitialStock(offer.type_id)
    }
  }, [offer])

  return (
    <>
      <>
        <ul className="new_offers_details_list" >
          <li className="new_offers_detail_item">
            <label className="new_offers_detail_label" title="Platform">
              {t('Type')}
            </label>
            <div className="new_offers_detail_value" title="PS4/PS5">
              <span>{offer.type_name ?? ""}</span>
            </div>
          </li>

          <li className="new_offers_detail_item">
            <label className="new_offers_detail_label" title="Amount">
              {t('price')}
            </label>
            <div className="new_offers_detail_value" title="100K" >
              <span>{offer.coins ? formateCoins(offer.coins) : ""}</span>
            </div>
          </li>

          {/* <li className="new_offers_detail_item">
            <label className="new_offers_detail_label" title="Complete Time">
              Complete Time
            </label>
            <div className="new_offers_detail_value" title="0.5-1Hour">
              <span>0.5-1Hour</span>
            </div>
          </li> */}
        </ul>

        <div className="new_offers_divider"></div>

        <div className="new_offers_total_section">
          <dl className="new_offers_total_container">
            <dt className="new_offers_total_label">{t('Montant')}</dt>
            <dd className="new_offers_total_amount">
              {offer.promotion && offer.promotion > 0 && (
                <span
                  style={{
                    textDecoration: "line-through",
                    color: "red",
                    fontSize: "14px",
                    marginRight: "10px",
                  }}
                >
                  {offer.montant
                    ? formatPrice(newpromotion(offer.montant, offer.promotion))
                    : ""}{" "}
                  {currency}
                </span>
              )}
              <span>{formatPrice(offer.montant - discount) ?? 0}</span>
              <span className="new_offers_currency">{currency}</span>
            </dd>
          </dl>

          {/* <button 
          disabled={!offer.coins || stock<offer.coins}
          style={{backgroundColor:!offer.coins || stock<offer.coins?"#ccc":"" ,cursor:!offer.coins || stock<offer.coins?"not-allowed":"pointer"}}
          onClick={openModal} className="new_offers_buy_button">
            {t("buyCoins")}
          </button> */}
        </div>
      </>
    </>
  );
}
